<template>
  <div class="supplement-detail">
    <div class="detail-card">
      <div class="field-grid">
        <div class="detail-field"><p>Mã tác vụ</p><div class="detail-value">{{ taskDetail.id || '-' }}</div></div>
        <div class="detail-field"><p>Phân loại</p><div class="detail-value">{{ taskDetail.subtype_label || taskDetail.category || 'Gia sư bổ trợ' }}</div></div>
        <div class="detail-field"><p>Mã lớp</p><div class="detail-value">{{ taskDetail.class_code || '-' }}</div></div>
        <div class="detail-field"><p>Trình độ học</p><div class="detail-value">{{ taskDetail.admin_level_name || '-' }}</div></div>
        <div class="detail-field"><p>Nội dung gia sư</p><div class="detail-value text-ellipsis" :title="competencyLabel">{{ competencyLabel }}</div></div>
        <div class="detail-field"><p>Link zalo bổ trợ</p><div class="detail-value"><a v-if="taskDetail.zalo_link" :href="taskDetail.zalo_link" target="_blank" rel="noopener noreferrer">{{ taskDetail.zalo_link }}</a><span v-else>-</span></div></div>
        <div class="detail-field"><p>Ngày làm</p><div class="detail-value">{{ formatDate(taskDetail.study_date || taskDetail.date) }}</div></div>
        <div class="detail-field"><p>Thời gian bắt đầu</p><div class="detail-value">{{ formatTime(taskDetail.start_time || taskDetail.study_time) }}</div></div>
        <div class="detail-field"><p>Thời gian kết thúc</p><div class="detail-value">{{ formatTime(taskDetail.end_time) }}</div></div>
        <div class="detail-field"><p>Số lượng học viên</p><div class="detail-value student-count"><span>{{ enrolledCount }}/{{ capacity }}</span><button type="button" class="detail-link" @click="$emit('open-students')">Xem chi tiết</button></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'SupplementTutorDetail',
  props: {
    taskDetail: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    studentCount() { return this.taskDetail.student_count || {}; },
    enrolledCount() { return this.studentCount.enrolled_count ?? this.taskDetail.students?.length ?? 0; },
    capacity() { return this.studentCount.capacity ?? this.taskDetail.capacity ?? 0; },
    competencyLabel() {
      return this.taskDetail.competency_name || this.taskDetail.competency_label || (this.taskDetail.competency_id ? `Năng lực ${this.taskDetail.competency_id}` : '-');
    }
  },
  methods: {
    formatDate(date) { return date ? moment(date).format('DD-MM-YYYY') : '-'; },
    formatTime(time) { if (!time) return '-'; return String(time).length === 5 ? `${time}:00` : time; }
  }
};
</script>

<style scoped>
.supplement-detail { width: 100%; }
.detail-card { background: #f6f6f6; border: 1px solid #000; border-radius: 3px; box-sizing: border-box; padding: 24px 20px 28px; }
.field-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 18px; }
.detail-field { min-width: 0; }
.detail-field p { color: #000; font-family: Inter, sans-serif; font-size: 13px; line-height: 18px; margin: 0 0 7px; }
.detail-value { align-items: center; background: #fff; border: 1px solid #d6d5d5; border-radius: 3px; box-sizing: border-box; display: flex; font-size: 13px; height: 32px; line-height: 18px; min-width: 0; overflow: hidden; padding: 0 15px; white-space: nowrap; }
.detail-value a { color: #454545; overflow: hidden; text-overflow: ellipsis; text-decoration: underline; }
.text-ellipsis { text-overflow: ellipsis; }
.student-count { justify-content: space-between; }
.detail-link { background: transparent; border: 0; color: #06f; cursor: pointer; flex-shrink: 0; font-size: 13px; margin-left: 8px; padding: 0; text-decoration: underline; }
@media (max-width: 768px) { .field-grid { grid-template-columns: 1fr; } }
</style>
